import { SiteIdEnum } from '@/js/enums/siteIds';

/**
 * The vulpr project this page belongs to.
 *
 * The server decides it per page (`VulprPageProjectResolver`) and injects it beside
 * `window.vulprSid`. Until 2026-09-17 the front-end sent the constant
 * `SiteIdEnum.SITE_ID` on every page of every vertical, which filed education and AI
 * pages under Crypto in vulpr.
 *
 * That constant stays as the fallback on purpose: a page rendered without the
 * injected variable -- a cached document, or a layout that does not include the
 * global variables partial -- keeps exactly the behaviour it has today rather than
 * dropping its project id or sending a meaningless one.
 */
export const getProjectId = (): number => {
    const injected = window.vulprProjectId;

    if (typeof injected === 'number' && Number.isInteger(injected) && injected > 0) {
        return injected;
    }

    return SiteIdEnum.SITE_ID;
};
